import { render, staticRenderFns } from "./AddSectionDialog.vue?vue&type=template&id=cea52f48&scoped=true&"
import script from "./AddSectionDialog.vue?vue&type=script&lang=js&"
export * from "./AddSectionDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddSectionDialog.vue?vue&type=style&index=0&id=cea52f48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea52f48",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {JrSection: require('/Users/jerei/Documents/宇浩/工作/nuxt2-demo/components/jr/Section.vue').default})
